<template>
    <div class="mx-3" style="width: 100%;" :style="showCommentForm === false ? 'max-height: 100%' : 'max-height: 300px'">
        <load
            mode="table"
            v-if="loading"
            message="Aguarde, estamos verificando se existem comentários."
        />
        <div class="row" v-else>
            <div
                class="col-12"
                v-for="comentario in comentarios"
                :key="comentario.id"
            >
                <div class="card mb-0">
                    <div class="card-body p-0 mb-2" :id="comentario.id">
                        <div
                            :style="`width: fit-content; min-width: 200px;${
                                comentario.usuario.id != $store.state.user.id
                                    ? 'float:left;'
                                    : 'float:right;'
                            }`"
                            class="p-3 border-0 rounded-lg"
                            :class="[
                                comentario.usuario.id != $store.state.user.id
                                    ? 'sb5 bg-cinza'
                                    : 'sb4 bg-azul',
                            ]"
                            v-html="comentario.mensagem"
                        ></div>
                    </div>
                    <div class="card-footer pb-0 border-0">
                        <div class="media mb-2">
                            <div class="media-body">
                                <div class="row">
                                    <div
                                        class="col-12 d-flex align-items-center px-0"
                                        :class="[
                                            comentario.usuario.id !=
                                            $store.state.user.id
                                                ? 'justify-content-start '
                                                : 'justify-content-end ',
                                        ]"
                                    >
                                        <div
                                            class="d-flex align-items-center"
                                            :class="[
                                                comentario.usuario.id !=
                                                $store.state.user.id
                                                    ? 'justify-content-start'
                                                    : 'justify-content-end flex-row-reverse',
                                            ]"
                                        >
                                            <img
                                                :alt="$t('User avatar')"
                                                :src="comentario.avatar"
                                                class="rounded-circle"
                                                style="width: 40px"
                                                :title="comentario.usuario.name"
                                                v-if="comentario.avatar"
                                            />

                                            <span
                                                style="line-height: 18px"
                                                :class="[
                                                    comentario.usuario.id !=
                                                    $store.state.user.id
                                                        ? 'text-left ml-2'
                                                        : 'text-right mr-2',
                                                ]"
                                            >
                                                <b>
                                                    <span
                                                        v-if="reply"
                                                        class="text-primary m-0"
                                                        :class="
                                                            comentario.usuario
                                                                .id !=
                                                            $store.state.user.id
                                                                ? 'float-left'
                                                                : 'float-right'
                                                        "
                                                        title="Responder comentário"
                                                        @click="
                                                            $emit(
                                                                'scroll',
                                                                comentario
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="mdi mdi-24px mdi-message-arrow-right mx-2"
                                                        ></i>
                                                    </span>
                                                    {{
                                                        comentario.usuario.name
                                                    }}
                                                </b>

                                                <br />
                                                <small class="text-muted">
                                                    {{
                                                        comentario.usuario.email
                                                    }}
                                                    -
                                                    {{ comentario.cadastrado }}
                                                </small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="card border redound">
          <div class="card-body p-3" v-html="comentario.mensagem"></div>
          <div class="card-footer pb-0 bg-light">
            <div class="media mb-2">
              <img
                src="/img/avatar_default.png"
                class="rounded-circle img-fluid px-0 mr-3"
                style="max-width: 40px; width: 100%"
              />
              <div class="media-body">
                <div class="row">
                  <div class="col-12">
                    <h5 class="float-left m-0">
                      {{ comentario.usuario.name }}
                    </h5>
                    <button
                      v-if="reply"
                      class="btn btn-secondary btn-sm float-right"
                      @click="$emit('scroll', comentario)"
                    >
                      <i class="mdi mdi-reply"></i> Responder
                    </button>
                  </div>

                  <div class="col-12">
                    <b v-if="comentario.usuario.tecnico">{{
                      comentario.usuario.tecnico.unidade.nome
                    }}</b>
                    - Enviado em :
                    {{ comentario.cadastrado }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

                <div
                    v-if="comentario.comentario_pai.length > 0"
                    class="col-12 p-3 mb-3 no-print border rounded"
                >
                    <div class="row d-flex justify-content-end px-2 mb-2">
                        <small> Resposta(s) ao comentario acima</small>
                    </div>
                    <comentarios
                        :comentarios="comentario.comentario_pai"
                        @scroll="scrollTop"
                        :reply="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["comentarios", "reply", "showCommentForm"],
    data() {
        return { loading: true };
    },
    beforeMount() {
        this.loading = false;
    },
    methods: {
        scrollTop(comentario) {
            this.$emit("scroll", comentario);
        },
    },
};
</script>
<style lang="css">
.sb4:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 12px solid #ebeef7;
    border-top: 5px solid #ebeef7;
    border-bottom: 7px solid transparent;
    right: 18px;
    bottom: -11px;
}

.sb5:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 12px solid #f5f5f5;
    border-right: 12px solid transparent;
    border-top: 5px solid #f5f5f5;
    border-bottom: 7px solid transparent;
    left: 18px;
    bottom: -11px;
}

.bg-azul {
    background: #ebeef7;
    color: #383838 !important;
}
.bg-cinza {
    background: #f5f5f5;
    color: #383838 !important;
}
</style>
